const state = {
    yulanImgList: []
}

const mutations = {
    SET_YULANIMGLIST: (state, data) => {
        state.yulanImgList = data
    }

}

const actions = {
    setYulanImgList( { commit }, data) {
        commit('SET_YULANIMGLIST', data)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
